if (typeof SliderComponent !== 'undefined') {
  class FeaturedCollectionCarousel extends SliderComponent {
    constructor() {
      super();

      if (!this.slider) return;

      this.enableSliderLooping = true;
      this.shuffleSlides();

      if (!this.nextButton) return;

      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');

      this.setupAutoplay();
    }

    onButtonClick(event) {
      event.preventDefault();
      const isNext = event.currentTarget.name === 'next';

      if (isNext && this.isAtEnd()) {
        this.jumpTo(0);
        return;
      }

      if (!isNext && this.isAtStart()) {
        this.jumpTo(this.slider.scrollWidth - this.slider.clientWidth);
        return;
      }

      super.onButtonClick(event);
    }

    isAtEnd() {
      return Math.ceil(this.slider.scrollLeft + this.slider.clientWidth) >= this.slider.scrollWidth;
    }

    isAtStart() {
      return this.slider.scrollLeft <= 0;
    }

    jumpTo(position) {
      this.slider.scrollTo({ left: position, behavior: 'instant' });
    }

    shuffleSlides() {
      const items = Array.from(this.sliderItems);

      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }

      items.forEach((item) => this.slider.appendChild(item));
      this.resetPages();
    }

    setupAutoplay() {
      if (this.slider.getAttribute('data-autoplay') !== 'true') return;

      this.autoplaySpeed = (parseFloat(this.slider.dataset.speed) || 5) * 1000;
      this.autoplayButton = this.querySelector('.carousel__autoplay');
      this.userPaused = false;
      this.isPlaying = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.resumeIfNotUserPaused.bind(this));
      this.addEventListener('focusin', this.pause.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.reducedMotion.addEventListener('change', this.onReducedMotionChange.bind(this));

      if (this.autoplayButton) {
        this.autoplayButton.addEventListener('click', this.toggleAutoplay.bind(this));
      }

      if (this.reducedMotion.matches) {
        this.togglePlayButtonState(true);
      } else {
        this.play();
      }
    }

    onFocusOut(event) {
      if (this.contains(event.relatedTarget)) return;
      this.resumeIfNotUserPaused();
    }

    onReducedMotionChange() {
      if (this.reducedMotion.matches) {
        this.pause();
      } else {
        this.resumeIfNotUserPaused();
      }
    }

    resumeIfNotUserPaused() {
      if (this.userPaused || this.reducedMotion.matches) return;
      this.play();
    }

    toggleAutoplay() {
      if (this.isPlaying) {
        this.userPaused = true;
        this.pause();
      } else {
        this.userPaused = false;
        this.play();
      }
    }

    play() {
      this.isPlaying = true;
      this.togglePlayButtonState(false);
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = setInterval(this.advanceSlide.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.isPlaying = false;
      this.togglePlayButtonState(true);
      clearInterval(this.autoplayTimer);
    }

    togglePlayButtonState(paused) {
      if (!this.autoplayButton) return;
      this.autoplayButton.classList.toggle('carousel__autoplay--paused', paused);
      this.autoplayButton.setAttribute(
        'aria-label',
        paused ? this.autoplayButton.dataset.labelPlay : this.autoplayButton.dataset.labelPause,
      );
    }

    advanceSlide() {
      if (!this.sliderItemOffset) return;

      if (this.isAtEnd()) {
        this.jumpTo(0);
        return;
      }

      this.setSlidePosition(this.slider.scrollLeft + this.sliderItemOffset);
    }
  }

  customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);
}
